import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { IEntrepreneurInfoItaly } from '~app/modules/account/modules/account-management/models/user-info.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyDetailsFromVatService {
  companyDetailsForTierTwo = new BehaviorSubject<IEntrepreneurInfoItaly>(null);
  companyDetailsForTierTwo$ = this.companyDetailsForTierTwo.asObservable();

  constructor() {}

  clearCompanyData() {
    this.companyDetailsForTierTwo.next(null);
  }

  postCompanyData(companyDetails: IEntrepreneurInfoItaly) {
    const {
      vatNumber,
      businessName,
      legalAddressCity,
      legalAddressProvince,
      legalAddressStreet,
      legalAddressPostalCode,
      legalAddressBuildingNumber,
      legalEmailAddress,
      legalAddressCountry,
    } = companyDetails;
    this.companyDetailsForTierTwo.next({
      vatNumber,
      businessName,
      legalAddressCity,
      legalAddressCountry,
      legalEmailAddress,
      legalAddressPostalCode,
      legalAddressStreet,
      legalAddressBuildingNumber,
      legalAddressProvince,
    });
  }
}
